export const SEMESTER = '/semester/' as const
export const SEMESTER_ALL = `${SEMESTER}all` as const
